//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';
import styled from 'styled-components';

import { BodyErrorText } from '@components/atoms/text/Text';

export interface RequestErrorProps {
  className?: string;
  error: string;
}

export const ErrorMessage = ({ className, error }: RequestErrorProps) => (
  <ErrorWrapper className={className}>
    <BodyErrorText>{error}</BodyErrorText>
  </ErrorWrapper>
);

const ErrorWrapper = styled.div(
  () => `
    width: 100%;
  `,
);
